<div ngbDropdown container="body" class="d-flex justify-content-evenly flex-wrap">
	<i data-testid="SUBSYS2_PATLIST_ACTION_EDIT" class="material-icons action"
		[title]="labels().PATIENT_ACTION_COMPONENT_EDIT" [class.disabled]="isReadonly()" (click)="edit($event)"
		(keypress)="edit($event)">
		assignment_ind
	</i>
	<i data-testid="SUBSYS2_PATLIST_ACTION_CREATEPLAN" class="material-icons action"
		[title]="labels().PATIENT_ACTION_COMPONENT_CREATE_PLAN" [class.disabled]="isReadonly()" (click)="createPlan($event)"
		(keypress)="createPlan($event)">
		post_add
	</i>
	@if (!hasPublishedRevoked()) {
	<i data-testid="SUBSYS2_PATLIST_ACTION_DELETE" class="material-icons action"
		[title]="labels().PATIENT_ACTION_COMPONENT_DELETE" [class.disabled]="isReadonly()" (click)="openDeleteModal($event)"
		(keypress)="openDeleteModal($event)">
		delete_outline
	</i>
	} @else {
	<i class="material-icons action hidden">circle</i>
	}

	@if (hasPublishedRevoked()) {
	<i data-testid="SUBSYS2_PATLIST_ACTION_MYHEXPLAN_SETTINGS" class="material-icons action"
		[title]="labels().PATIENT_ACTION_COMPONENT_MYHEXPLAN_SETTINGS" [class.disabled]="isReadonly()"
		(click)="viewPatientSettings($event)" (keypress)="viewPatientSettings($event)">
		manage_accounts
	</i>
	<i data-testid="SUBSYS2_PATLIST_ACTION_MYHEXPLAN_HISTORY" class="material-icons action"
		[title]="labels().PATIENT_ACTION_COMPONENT_MYHEXPLAN_HISTORY" [class.disabled]="isReadonly()"
		(click)="viewPatientHistory($event)" (keypress)="viewPatientHistory($event)">
		history
	</i>
	} @else {
	<i class="material-icons action hidden">circle</i>
	<i class="material-icons action hidden">circle</i>
	}
</div>